import { css } from '@/styled-system/css';

export const bannerCloseStyles = css.raw({
  flexShrink: '0',
  insetBlockStart: 'Banner.CloseButton.margin.top',
  insetInlineEnd: 'Banner.CloseButton.margin.right',
  marginBlockStart: `calc(-1 * {spacing.default})`,
  marginInlineEnd: `calc(-1 * {spacing.default})`,
});
